import * as React from 'react';

function SvgValidate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
      <path d="M22.43 5H9.57A2.54 2.54 0 007 7.5v21.25c0 .46.26.89.68 1.1.42.22.92.2 1.32-.06l7-4.54 7 4.54a1.31 1.31 0 001.32.06c.42-.21.68-.64.68-1.1V7.5C25 6.12 23.85 5 22.43 5zM14.7 20.31l-4.8-4.68 1.67-1.67 3.15 3.07 6.7-7.11 1.68 1.85-8.38 8.54z" />
    </svg>
  );
}

export default SvgValidate;
